/**
 * Service-worker registrar. Imported once from `index.js`.
 *
 * We deliberately register lazily on the `load` event so the initial
 * navigation render isn't blocked by SW boot. Failures are swallowed —
 * a missing/blocked SW must never break the app shell.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Disable in non-secure contexts (HTTP) — Chrome refuses to register otherwise.
  if (!window.isSecureContext && window.location.hostname !== 'localhost') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      // updateViaCache='none' ensures the SW file itself is never served
      // from HTTP cache — without this, a stale SW lingers forever and
      // keeps the old caching strategy alive even after we deploy a fix.
      .register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .then((reg) => {
        // Force an immediate update check so a deploy is picked up on
        // the next reload instead of waiting up to 24h.
        try { reg.update(); } catch (_) {}
      })
      .catch(() => {
        // Silently ignore — the app still works without SW.
      });
  });
}
